import React from 'react';

// helpers
import { formateDateandTime } from "../../../helpers/formats.js";

export default function InspecoesImpressao({ boletimVistoria }) {

    return (
        <>
            {boletimVistoria.boletimVistoriaInspecoes.map((m, key) => (
                <div className="contentGroup" key={key}>
                    <h5 className="subtitleCardInfo">Inspeção: {m.local}</h5>
                    <div className="row align-items-end">
                        <div className="col-12 pb-2">
                            <strong>Endereço: </strong><span>{m.logradouro + ", " + m.bairro}</span>
                        </div>                    
                        <div className="col-6 pb-2">
                            <strong>Início: </strong><span>{formateDateandTime(m.dataHoraInicio)}</span>
                        </div>
                        <div className="col-6 pb-2">
                            <strong>Fim: </strong><span>{formateDateandTime(m.dataHoraFim)}</span>
                        </div>
                    </div>

                    {/* Novo Bloco de Evidências Gerais da Inspeção para Impressão */}
                    {(() => {
                        const fotosGerais = m.boletimVistoriaInspecaoFotos.filter(f => !f.formularioVistoriaQuestao_Id);
                        if (fotosGerais.length > 0) {
                            return (
                                <div className="mt-4 mb-2">
                                    <h6 className="mb-3 font-weight-bold" style={{ color: '#444', borderLeft: '5px solid #17a2b8', paddingLeft: '10px' }}>
                                        Evidências da Inspeção
                                    </h6>
                                    <div className="row justify-content-center">
                                        {fotosGerais.map((foto, keyfoto) => (
                                            <div className="col-4 mb-3" key={keyfoto}>
                                                <div className="foto-card-premium">
                                                    <div className="foto-img-wrapper">
                                                        <img src={foto.nomeArquivo} alt={`Evidência Geral ${m.local}`} />
                                                    </div>
                                                    <div className="foto-info">
                                                        {foto.dataHoraArquivo && (
                                                            <div className="foto-meta-item">
                                                                <i className="far fa-clock foto-meta-icon"></i> 
                                                                <span><strong>Data:</strong> {formateDateandTime(foto.dataHoraArquivo)}</span>
                                                            </div>
                                                        )}
                                                        {foto.geoLocalizacao && (
                                                            <div className="foto-meta-item">
                                                                <i className="fas fa-map-marker-alt foto-meta-icon"></i> 
                                                                <span><strong>Lat/Long:</strong> {foto.geoLocalizacao.replace(';', ', ')}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        }
                        return null;
                    })()}

                    <div className="mt-4 border rounded bg-white overflow-hidden shadow-sm">
                        {/* Custom Table Header */}
                        <div className="row bg-light border-bottom py-2 px-3 font-weight-bold" style={{ fontSize: '1rem', color: '#444' }}>
                            <div className="col-6">Pergunta</div>
                            <div className="col-6">Resposta</div>
                        </div>

                        {/* Custom Table Body */}
                        {m.boletimVistoriaQuestoes.map((n, key2) => {
                             const fotosQuestao = m.boletimVistoriaInspecaoFotos.filter(f => f.formularioVistoriaQuestao_Id === n.formularioVistoriaQuestao_Id);
                             return (
                                <div key={key2} className="border-bottom py-3 px-3" style={{ backgroundColor: key2 % 2 === 0 ? '#fff' : '#fafafa' }}>
                                    <div className="row align-items-start">
                                        <div className="col-6 font-weight-bold" style={{ color: '#333' }}>
                                            {n.formularioVistoriaQuestao_Identificacao}
                                        </div>
                                        <div className="col-5">
                                            {n.valor}
                                        </div>
                                        <div className="col-1 text-right">
                                            {n.penalidade && <i className="fas fa-exclamation-circle text-danger"></i>}
                                        </div>
                                    </div>

                                    {/* Question Photos - Dedicated Second Row */}
                                    {fotosQuestao.length > 0 &&
                                        <div className="row mt-3 justify-content-center">
                                            {fotosQuestao.map((foto, keyfoto) => (
                                                <div className="col-4 mb-3" key={keyfoto}>
                                                    <div className="foto-card-premium">
                                                        <div className="foto-img-wrapper">
                                                            <img src={foto.nomeArquivo} alt={`Foto da questão ${n.formularioVistoriaQuestao_Identificacao}`} />
                                                        </div>
                                                        <div className="foto-info">
                                                            {foto.dataHoraArquivo && (
                                                                <div className="foto-meta-item">
                                                                    <i className="far fa-clock foto-meta-icon"></i> 
                                                                    <span><strong>Data:</strong> {formateDateandTime(foto.dataHoraArquivo)}</span>
                                                                </div>
                                                            )}
                                                            {foto.geoLocalizacao && (
                                                                <div className="foto-meta-item">
                                                                    <i className="fas fa-map-marker-alt foto-meta-icon"></i> 
                                                                    <span><strong>Lat/Long:</strong> {foto.geoLocalizacao.replace(';', ', ')}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </div>
                             );
                        })}
                    </div>

                    <div className="mt-4">
                        <label><i className="fas fa-exclamation-circle text-danger"></i> Respondido com inconformidade</label>
                    </div>                    
                </div>
            ))}
        </>
    );
}

